import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import shieldCheck from 'assets/img/shield-check.svg';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import enable from 'assets/img/profile/enable.png';
import disable from 'assets/img/profile/disable.png';
import * as action from '../action';
import * as c from '../constant';
import AuthenticationModal from '../modals/AuthenticationModal';
import EditProfileModal from '../modals/EditProfileModal';
import SuccessModal from '../modals/SuccessModal';
import EmailSetupModal from '../modals/EmailSetupModal';

function Profile({ profile, getProfile, generate2fa, updateMfa }) {
  const UpdateInfo = () => {
    getProfile();
  };

  const setModal = useContext(ModalContext);

  const [formData, setFormData] = useState({});

  const OnSetFormData = () => {
    setFormData({
      preferred_mfa: profile.attributes.preferred_mfa || '',
    });
  };

  useEffect(() => {
    if (!_.isEmpty(profile)) {
      OnSetFormData();
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(profile)) {
      OnSetFormData();
    }
  }, [profile]);

  const status = sessionStorage.getItem('status');

  const handleSuccessModal = () => {
    if (status === 'enabled') {
      setModal({
        isOpen: true,
        content: <SuccessModal UpdateInfo={UpdateInfo} />,
        title: null,
        modalSize: 'modal-md',
      });
    }
  };

  const onGenerate2FA = e => {
    e.preventDefault();
    const args = {
      email: formData.email
    };

    generate2fa(args, (data) => {
      setModal({
        title: "Multi-Factor Authentication",
        isOpen: true,
        content: <AuthenticationModal item={data} id={profile.id} handleSuccessModal={handleSuccessModal} />,
        modalSize: 'modal-md',
      });
    })
  }

  // const onDisabled2FA = e => {
  //   e.preventDefault();
  //   setModal({
  //     title: "Disable 2fa",
  //     isOpen: true,
  //     content: <PasswordModal />,
  //     modalSize: 'modal-md',
  //   });
  // };

  const handleEditProfile = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <EditProfileModal UpdateInfo={UpdateInfo} />,
      title: 'Edit Profile',
      modalSize: 'modal-md',
    });
  };

  const onChangeRadio = data => e => {
    e.preventDefault();
    const args = {
      ...formData,
      preferred_mfa: data
    };
    if (data === 'google_authenticator') {
      ConfirmAlert(
        'Are you sure you want to use Authenticator App as your preferred method on login?',
        () => {
          updateMfa(args, () => {
            UpdateInfo();
          });
        },
        () => { },
        {
          yesLabel: 'Confirm',
          noLabel: 'Cancel',
        }
      );
    }

    if (data === 'email_otp') {
      ConfirmAlert(
        'Are you sure you want to use Email Authentication as your preferred method on login?',
        () => {
          updateMfa(args, () => {
            UpdateInfo();
          });
        },
        () => { },
        {
          yesLabel: 'Confirm',
          noLabel: 'Cancel',
        }
      );
    }

  };

  useEffect(() => {
    UpdateInfo();
  }, []);

  const showEmailModal = () => {
    setModal({
      isOpen: true,
      content: <EmailSetupModal profileInfo={profile} />,
      title: "Multi-Factor Authentication",
      modalSize: 'modal-md',
    });
  };

  return (
    <div className="module-inner">
      <div className="module-inner-title">Admin Profile</div>
      <div className="card">
        <div className='card-body'>
          <div className="container-fluid">
            <div className="p-0 d-flex flex-nowrap w-100">
              <div className="profile">
                <div className='label'>
                  Personal information
                </div>
                <div className='title'>
                  Manage personal information relating to your admin account.
                </div>
              </div>
              <div className='ml-auto'>
                <button
                  type="button"
                  className="btn btn-black px-4 ml-auto"
                  onClick={handleEditProfile}
                >
                  Edit Profile
                </button>
              </div>
            </div>
          </div>
          <div className='row mt-2'>
            <div className="col-md-2">
              <img
                src={
                  _.isNil(_.get(profile, 'attributes.photo')) ||
                    _.get(profile, 'attributes.photo') === null
                    ? ImagePlaceholder
                    : _.get(profile, 'attributes.photo')
                }
                className="rounded-circle avatar-thumbnail"
                alt="Name"
              />
            </div>
            <div className="col-md-10 row mt-3">
              <div className="row">
                <div className="row">
                  <div className="col-6">
                    <div className="detail-field">
                      <span className="detail-title text-muted">
                        Name
                      </span>
                      <p className="detail-body mt-1 text-black font-weight-bold">
                        {_.get(profile, 'attributes.first_name')} {_.get(profile, 'attributes.middle_name') || ''} {_.get(profile, 'attributes.last_name')}
                      </p>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="detail-field">
                      <span className="detail-title text-muted">
                        Role
                      </span>
                      <p className="detail-body mt-1 text-black font-weight-bold">
                        {_.get(profile, 'attributes.profile_type') || '--'}
                      </p>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="detail-field">
                      <span className="detail-title text-muted">
                        Email
                      </span>
                      <p className="detail-body mt-1 text-black font-weight-bold">
                        {_.get(profile, 'attributes.email') || '--'}
                      </p>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="detail-field">
                      <span className="detail-title text-muted">
                        Mobile No.
                      </span>
                      <p className="detail-body mt-1 text-black font-weight-bold">
                        {_.get(profile, 'attributes.mobile_number') || '--'}
                      </p>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="detail-field">
                      <span className="detail-title text-muted">
                        Telephone No.
                      </span>
                      <p className="detail-body mt-1 text-black font-weight-bold">
                        {_.get(profile, 'attributes.telephone_number') ||
                          '--'}
                      </p>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="detail-field">
                      <span className="detail-title text-muted">
                        Address
                      </span>
                      <p className="detail-body mt-1 text-black font-weight-bold">
                        {_.get(profile, 'attributes.address') || '--'}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr className="w-80 p-1" />
          <div className="d-flex justify-content-between align-items-center">
            <div className="col-8">
              <div className="profile">
                <div className='label'>
                  Account Security
                </div>
                <div className='title'>
                  Multi-factor Authentication is currently enabled.
                  <span className='ml-2'>
                    <img
                      alt=""
                      src={shieldCheck}
                      className="icon"
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="flex-row justify-content-center px-0 mx-0 mt-3">
            <div className="col-8">
              <div className='d-flex'>
                <div className='mt-2 mr-3'>
                  <i className="fas fa-lock icon-lock" />
                </div>
                <div className="account-security-button">
                  <div className='title'>
                    Preferred Method on Login
                  </div>
                  <div className='d-flex'>
                    <button
                      type="button"
                      disabled={_.get(profile, 'attributes.google2fa_enable') === false}
                      onClick={onChangeRadio('google_authenticator')}
                      className={`align-items-center radio-button mr-2 ${_.get(formData, 'preferred_mfa') === 'google_authenticator' ? 'preferred' : ''}`}
                    >
                      <input
                        className={`${_.get(formData, 'preferred_mfa') === 'google_authenticator' ? 'selected' : 'inactive'}`}
                        type="radio"
                        name="preferred_mfa"
                        disabled={_.get(profile, 'attributes.google2fa_enable') === false}
                        onChange={onChangeRadio('google_authenticator')}
                        checked={_.get(formData, 'preferred_mfa') === 'google_authenticator'}
                        value={_.get(formData, 'preferred_mfa') === 'google_authenticator' ? 1 : 0}
                      />
                      <label className="label mb-0 mx-1">Authenticator App</label>
                    </button>

                    <button
                      type="button"
                      disabled={_.get(profile, 'attributes.is_email_2fa_enabled') === false}
                      onClick={onChangeRadio('email_otp')}
                      className={`align-items-center radio-button ${_.get(formData, 'preferred_mfa') === 'email_otp' ? 'preferred' : ''}`}
                    >
                      <input
                        className={`${_.get(formData, 'preferred_mfa') === 'email_otp' ? 'selected' : 'inactive'}`}
                        type="radio"
                        name="preferred_mfa"
                        disabled={_.get(profile, 'attributes.is_email_2fa_enabled') === false}
                        onChange={onChangeRadio('email_otp')}
                        checked={_.get(formData, 'preferred_mfa') === 'email_otp'}
                        value={_.get(formData, 'preferred_mfa') === 'email_otp' ? 1 : 0}
                      />
                      <label className="label mb-0 mx-1">Email Authentication</label>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div className="d-flex justify-content-between align-items-center mt-2">
            <div className="col-8">
              <div className='d-flex'>
                {_.get(profile, 'attributes.google2fa_enable') === false ? (
                  <div className='mt-2 mr-3'>
                    <img
                      alt=""
                      src={disable}
                      className="profile-icon"
                    />
                  </div>
                ) : (
                  <div className='mt-2 mr-3'>
                    <img
                      alt=""
                      src={enable}
                      className="profile-icon"
                    />
                  </div>
                )}

                <div className="account-security">
                  <div className='title'>
                    Authenticator App
                  </div>
                  <div className='description'>
                    Use an app on your phone to generate verification codes when logging in.
                  </div>
                </div>
              </div>
            </div>
            <div className="col-2 d-flex">
              <div className="ml-auto">
                <button
                  type="button"
                  onClick={onGenerate2FA}
                  className="btn button-update mr-3"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
          <hr />
          <div className="d-flex mt-2">
            <div className="align-item-start ml-3">
              <div className='d-flex'>
                {_.get(profile, 'attributes.is_email_2fa_enabled') === false ? (
                  <div className='mt-2 mr-3'>
                    <img
                      alt=""
                      src={disable}
                      className="profile-icon"
                    />
                  </div>
                ) : (
                  <div className='mt-2 mr-3'>
                    <img
                      alt=""
                      src={enable}
                      className="profile-icon"
                    />
                  </div>
                )}
                <div className="account-security">
                  <div className='title'>
                    Email Authentication
                  </div>
                  <div className='description'>
                    Enter a one-time pin (OTP) sent to your registered email address.
                  </div>
                </div>
              </div>
            </div>
            <div className="align-item-end ml-auto mt-3">
              {_.get(profile, 'attributes.is_email_2fa_enabled') === false ? (
                <button
                  type="button"
                  onClick={showEmailModal}
                  className="btn button-update mr-3"
                >
                  Verify your email address
                </button>
              ) : (
                <div className="account-security">
                  <div className='description'>
                    Codes will be sent to your registered email ({_.get(profile, 'attributes.email')})
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

Profile.propTypes = {
  profile: PropTypes.instanceOf(Object).isRequired,
  getProfile: PropTypes.instanceOf(Function).isRequired,
  generate2fa: PropTypes.instanceOf(Function).isRequired,
  updateMfa: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  profile: _.get(api, `${c.GET_PROFILE}.item`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(Profile);